import {Component, OnDestroy, OnInit, Input, Injector} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventManager, AccountService } from 'src/app/core';
import { ProductService } from '../../product.service';
import { ToastrService } from 'ngx-toastr';
import { ManageComponent } from 'src/app/shared/components/manage.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { UpdateNavPopupComponent } from '../update-nav-popup/update-nav-popup.component';

@Component({
  selector: 'app-nav-list',
  templateUrl: './nav-list.component.html',
  styleUrls: ['./nav-list.component.scss']
})
export class NAVListComponent extends ManageComponent implements OnInit, OnDestroy {
  @Input() title: any;
  @Input() list?: any[];
  @Input() queryParams: any = {};
  @Input() searchParams: any = {};
  setting: any = {};
  constructor(
  public injector: Injector,
    public eventManager: EventManager,
    public router: Router,
    private productService: ProductService,
    public modalService: NzModalService,
    private toastService: ToastrService
  ) {
    super(eventManager, modalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subscriptions.push(
      this.eventManager.subscribe('load-nav', (res) => {
        this.executeCallAPI();
      }),
    );
    this.executeCallAPI();
  }
  loadAll(req?: any) {
    req = req || this.queryParams;
    this.list = [];
    return this.productService.getListNAV(req)
    .subscribe(this.onResponse.bind(this));
  }
  afterSuccess(response) {
    this.list.forEach((item) => {
      (item.productNavInDtoList || []).forEach((product) => {
        if (product.percent <= 96 || product.percent >= 104) {
          product.isHighligt = true;
        }
      })
    });
  }
  approve() {
    const body = {
      requestChangeNavId: this.selectedItem.navChangeRequestId
    }
    this.productService.approveUploadNAV(body)
    .subscribe((res) => {
      this.toastService.success('Duyệt yêu cầu Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmApprove(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn duyệt yêu cầu này : ${selectedItem.navChangeRequestId}`, this.approve.bind(this));
  }
  reject() {
    const body = {
      requestChangeNavId: this.selectedItem.navChangeRequestId
    }
    this.productService.rejectUploadNAV(body)
    .subscribe((res) => {
      this.toastService.success('Từ chối yêu cầu Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmReject(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn từ chối yêu cầu này : ${selectedItem.navChangeRequestId}`, this.reject.bind(this));
  }
  openPopupNAV() {
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzOkDisabled: true,
      nzContent: UpdateNavPopupComponent,
      nzFooter: null,
      nzData: {
      },
      nzOnOk: (() => { })
    });
  }
}
